export default __webpack_public_path__ + "static/media/logo-orthopod.ab5eb648.jpg";